export const SELF_SERVE_PLANS = [
    { key: 'free', label: 'Free', includedConversations: 40 },
    { key: 'starter', label: 'Starter', includedConversations: 200 },
    { key: 'growth', label: 'Growth', includedConversations: 500 },
    // Staff-assigned, any client type. null = unlimited.
    { key: 'custom', label: 'Custom', includedConversations: null },
] as const;

export type SelfServePlan = (typeof SELF_SERVE_PLANS)[number]['key'];
export type SelfServePlanDefinition = (typeof SELF_SERVE_PLANS)[number];

export interface SelfServePlanAssignment {
    plan: SelfServePlan;
    /** null = unlimited (Custom). */
    monthlyConversationLimit: number | null;
    quotaStartedAt: string | null;
}

export function isSelfServePlan(value: unknown): value is SelfServePlan {
    return SELF_SERVE_PLANS.some((plan) => plan.key === value);
}

export function getSelfServePlan<P extends SelfServePlan>(
    plan: P
): Extract<SelfServePlanDefinition, { key: P }> {
    const definition = SELF_SERVE_PLANS.find((candidate) => candidate.key === plan);
    if (!definition) {
        throw new Error(`Unknown self-serve plan: ${plan}`);
    }
    return definition as Extract<SelfServePlanDefinition, { key: P }>;
}
